import { IBeginShoppingRequest } from "../entities-generated/models/project/begin-shopping-request";
import { IBeginShoppingResponse } from "../entities-generated/models/project/begin-shopping-response";
import { IProjectConfiguration } from "../entities-generated/models/project/project-configuration";
import { AuthApiClient } from "./auth-api-client";

class ShopAuthApiClientClass {
  public verifyShoppingCredentials(request: IBeginShoppingRequest) {
    return AuthApiClient.post<IBeginShoppingResponse>('shop/verify', request);
  }

  public getProjectConfiguration(token: string) {
    AuthApiClient.sideLoadToken(token);
    return AuthApiClient.get<IProjectConfiguration>('shop/my-project');
  }
}

export const ShopAuthApiClient = new ShopAuthApiClientClass();